import React from 'react';
import { DropdownSelect } from '../../../../components/Dropdown';
import { BasePdfComponent, PdfTextAlign, PdfVerticalAlign } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';

interface WithTextAlignProperties extends BasePdfComponent {
  align: PdfTextAlign;
  valign: PdfVerticalAlign;
}

export default function PdfTemplateComponentTextAlignment<T>({ component }: { component: WithTextAlignProperties }) {
  const { updateComponent } = usePdfTemplateContext<T>();

  return (
    <div className='grid grid-cols-2 gap-2'>
      <DropdownSelect
        label='Horizontal Align'
        items={Object.values(PdfTextAlign)}
        value={component.align}
        textBuilder={s => s}
        onSelect={align => updateComponent(component.id, { align })}
      />
      <DropdownSelect
        label='Vertical Align'
        items={Object.values(PdfVerticalAlign)}
        value={component.valign}
        textBuilder={s => s}
        onSelect={valign => updateComponent(component.id, { valign })}
      />
    </div>
  );
}
